__turbopack_context__.v({
  "become-producer": "_3_A-1a_become-producer",
  "become-producer-left": "_3_A-1a_become-producer-left",
  "become-producer-right": "_3_A-1a_become-producer-right",
  "img": "_3_A-1a_img",
});
